import { IKehoachNam } from "../../../model/respone/category/IKehoachNam";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachNamActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IKehoachNam[],
  LOAD_ERRR: "",
};
export const eKeHoachNamActionIds = generateActionTypeIds(
  eKeHoachNamActionsObj,
  "KE_HOACH_NAM"
);
export type IKeHoachNamActionTypes = IGenericActionType<
  typeof eKeHoachNamActionsObj,
  "KE_HOACH_NAM"
>;
